module.exports = __webpack_public_path__ + "static/media/barbearia.20bba703.svg";